import reducer from './reducer';
import operations from './operations';
import actions from './actions';

export {
    operations as presetsPageOperations,
    actions as presetsPageActions
};

export default reducer;
